import { ChangeEmailConfirmation } from "components/changeEmail/ChangeEmailConfirmation/ChangeEmailConfirmation";
import { AuthBoundary } from "components/common/AuthBoundary/AuthBoundary";
import { Footer } from "components/common/Footer/Footer";
import { Home } from "components/common/Home/Home";
import { Header } from "components/common/Menu/Menu";
import { DeleteAccountConfirmation } from "components/deleteAccount/DeleteAccountConfirmation/DeleteAccountConfirmation";
import { ChangeEmailError, DeleteAccountError } from "components/settings/SettingsError/SettingsError";
import { useLocalisedDocumentTitle } from "components/_hooks/useLocalisedDocumentTitle";
import React from "react";
import { Route, Switch } from "react-router-dom";
import { routes } from "routes";

const WithHeaderFooter = () => {
  return (
    <>
      <Header isAuthenticated={true} /> {/* Always authenticated because inside AuthBoundary  */}
      <Switch>
        <Route path={routes.deleteAccountError} component={DeleteAccountError} />
        <Route path={routes.changeEmailError} component={ChangeEmailError} />
        <Route component={Home} />
      </Switch>
      <Footer />
    </>
  );
};

export const AuthenticatedApp = () => {
  useLocalisedDocumentTitle();
  return (
    <AuthBoundary>
      <Switch>
        {/* Authenticated but without the header and footer  */}
        <Route path={routes.deleteAccountConfirmation} component={DeleteAccountConfirmation} />
        <Route path={routes.changeEmailConfirmation} component={ChangeEmailConfirmation} />
        {/* Authenticated with header and footer  */}
        <Route component={WithHeaderFooter} />
      </Switch>
    </AuthBoundary>
  );
};

export default AuthenticatedApp;
